import { GET_LEDGER } from "../../actions/type";

export default function ledger(state = {}, action) {
    switch (action.type) {
        case GET_LEDGER:
            return action.payload;;
        default:
            return state
    }
}